import React from 'react';
import { FaPaypal, FaCreditCard, FaLock, FaHeart, FaHandHoldingHeart } from 'react-icons/fa';
import './Donations.css';

const HELLOASSO_URL = process.env.REACT_APP_HELLOASSO_URL || 'https://www.helloasso.com/associations/rive/formulaires/1';
const PAYPAL_URL = process.env.REACT_APP_PAYPAL_URL || 'https://www.paypal.com/donate';

const paymentOptions = [
  {
    title: 'Don via HelloAsso',
    description: 'Plateforme française de référence pour les dons aux associations. Reçu fiscal automatique.',
    cta: 'Donner avec HelloAsso',
    url: HELLOASSO_URL,
    icon: <FaHandHoldingHeart />
  },
  {
    title: 'Carte bancaire',
    description: 'Paiement sécurisé par carte bancaire via HelloAsso.',
    cta: 'Donner par carte',
    url: HELLOASSO_URL,
    icon: <FaCreditCard />
  },
  {
    title: 'Don via PayPal',
    description: 'Paiement direct et sécurisé avec votre compte PayPal.',
    cta: 'Donner avec PayPal',
    url: PAYPAL_URL,
    icon: <FaPaypal />
  }
];

function Donations() {
  return (
    <article className="page type-page status-publish hentry donations-page">
      <header className="entry-header donations-hero">
        <div className="donations-hero-inner">
          <p className="eyebrow">Soutenir RIVE</p>
          <h1 className="entry-title">Faites un don en quelques clics</h1>
          <p className="lead">
            Chaque contribution permet de financer les repas, les produits essentiels et l&apos;accompagnement des
            femmes et familles accueillies. Choisissez le moyen de paiement qui vous convient.
          </p>
          <div className="hero-badges">
            <span className="pill pill-secure"><FaLock /> Paiement sécurisé</span>
            <span className="pill pill-impact"><FaHeart /> Impact immédiat</span>
          </div>
        </div>
      </header>

      <div className="entry-content donations-content">
        <section className="payment-options" id="paiement">
          <h2>Choisissez votre mode de don</h2>
          <div className="payment-grid">
            {paymentOptions.map((option) => (
              <div className="payment-card" key={option.title}>
                <div className="icon">{option.icon}</div>
                <h3>{option.title}</h3>
                <p>{option.description}</p>
                <a className="btn primary" href={option.url} target="_blank" rel="noopener noreferrer">
                  {option.cta}
                </a>
              </div>
            ))}
          </div>
          <p className="note">
            Vous disposez de liens spécifiques ? Renseignez-les dans les variables
            d&apos;environnement <code>REACT_APP_HELLOASSO_URL</code> et <code>REACT_APP_PAYPAL_URL</code>.
          </p>
        </section>

        <section className="faq">
          <h2>Questions fréquentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Les paiements sont-ils sécurisés ?</h4>
              <p>Toutes les transactions sont chiffrées et traitées par les prestataires de paiement.</p>
            </div>
            <div className="faq-item">
              <h4>Puis-je recevoir un reçu fiscal ?</h4>
              <p>Oui, contactez-nous après votre don pour recevoir une attestation.</p>
            </div>
            <div className="faq-item">
              <h4>Je préfère un virement bancaire.</h4>
              <p>Écrivez-nous à accueilrive@yahoo.com pour recevoir notre RIB et les instructions.</p>
            </div>
          </div>
        </section>
      </div>
    </article>
  );
}

export default Donations;

